// @flow

export const locationToPointLocation = (location:Location):string => {
  return `POINT(${location.longitude}+${location.latitude})`
}